import { render, staticRenderFns } from "./AppPortal.vue?vue&type=template&id=666bcfba&scoped=true&"
import script from "./AppPortal.vue?vue&type=script&lang=js&"
export * from "./AppPortal.vue?vue&type=script&lang=js&"
import style0 from "./AppPortal.vue?vue&type=style&index=0&id=666bcfba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666bcfba",
  null
  
)

export default component.exports